import { combineReducers } from 'redux';
import api from './apiSlice';

import search from './searchSlice';
import authReducer from './auth';
import billedEntities from './billedEntitiesSlice';
import apiVersion from './apiVersionSlice';
import deleteMode from './deleteModeSlice';
import sse from './sseSlice';

export default combineReducers({
  api,
  auth: authReducer,
  search,
  billedEntities,
  apiVersion,
  deleteMode,
  sse,
});
